export const DEVICE_STATUSES = {
  OPERATIONAL: 'operational',
  UNREACHABLE: 'unreachable',
  NOT_CONFIGURED: 'not_configured'
} as const

export type DeviceStatus = typeof DEVICE_STATUSES[keyof typeof DEVICE_STATUSES]

interface DeviceStatusInput {
  is_provisioning: boolean
  is_reachable: boolean
}

export const getDeviceStatus = ({ is_provisioning, is_reachable }: DeviceStatusInput): DeviceStatus => {
  if (!is_provisioning) return DEVICE_STATUSES.NOT_CONFIGURED
  return is_reachable ? DEVICE_STATUSES.OPERATIONAL : DEVICE_STATUSES.UNREACHABLE
}
